// Author Lin
// Date 2022-01-19 17:43:54

import * as model from "@/model/sithMes/inventory/SithMesInventoryStockReturnModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesInventoryStockReturn(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_INVENTORY_URL,
    })
    .buildStore()
